// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout_wrapper__xfcTf","content":"Layout_content__NTjFR","main":"Layout_main__3tybh"};